export const cmvReportV2 = {
	label: "CMV",
	description:
		"COGS (Cost of Goods Sold) is a financial indicator that represents direct costs.",
	states: {
		empty: {
			title: "No CMV data found",
			description: "There is no CMV information for the selected period.",
		},
		error: {
			title: "Unable to load CMV",
			description:
				"An error occurred while loading the CMV report. Please try again shortly.",
		},
	},
	kpis: {
		itemsSold: "Items sold",
		grossRevenue: "Gross revenue",
		totalCost: "Total cost",
		marginCmv: "CMV margin",
		cmvPercent: "CMV percentage",
	},
	header: {
		periodPlaceholder: "Select period",
		export: "Export Excel",
		type: {
			all: "All products",
			fromPlace: "Place products",
			fromVendor: "Vendor products",
		},
	},
	filters: {
		searchPlaceholder: "Search by product or SKU",
		categoriesPlaceholder: "All categories",
		viewBy: {
			byCategory: "View by categories",
			byProduct: "View by products",
		},
	},
	chart: {
		title: "Revenue vs CMV by category",
		legend: {
			revenue: "Revenue",
			cmv: "CMV",
		},
		tooltip: {
			revenue: "Revenue",
			cmv: "CMV",
		},
		empty: {
			title: "No chart data",
			description: "No categories with sales for the selected period and filters.",
		},
	},
	table: {
		columns: {
			category: "CATEGORY",
			soldQty: "SOLD QTY",
			grossRevenue: "GROSS REVENUE",
			totalCost: "TOTAL COST",
			costPercent: "COST PERCENTAGE",
			cmv: "COGS",
			margin: "MARGIN",
			product: "Product",
			sku: "SKU",
			productSoldQty: "Sold qty",
			losses: "Losses",
			unitValue: "Unit value",
			unitCost: "Unit cost",
			productTotalValue: "Total value",
			productTotalCost: "Total cost",
			productMargin: "Margin",
			productCmv: "COGS",
		},
		empty: {
			title: "No products found",
			description: "There are no products for the selected filters.",
		},
	},
};
